/**
 * Created by anunez on 18/07/2018.
 */
import {Injectable} from '@angular/core';
import {IResourceMethod, Resource, ResourceAction, ResourceHandler, ResourceParams, ResourceRequestMethod} from '@ngx-resource/core';
import {PaidPaymentModel} from '../model/paid-payment.model';
import {environment} from '../../../environments/environment';

@Injectable()
@ResourceParams({
   url: environment.apiBaseUrl + '/api/payments/na'
 // url: 'http://187.217.231.173:9938/api/payments/na'
})
export class PaidPaymentResource extends Resource {
  constructor(restHandler: ResourceHandler) {
    super(restHandler);
  }
  @ResourceAction({
    path: '/paid_payments',
    method: ResourceRequestMethod.Post
  })
  savePaidPayment: IResourceMethod<PaidPaymentModel , any>;
}
